export const TNC_TYPE = {
  accessories: 'Aksesoris',
  homePage: 'Homepage',
  couponServicePage: 'Kupon Service',
  packageServicePage: 'Paket Service',
  registerPage: 'Pendaftaran Akun',
  bookingServicePage: 'Booking Service',
  checkoutPage: 'Checkout',
  orderSukuCadang: 'Order Suku Cadang',
  testDrive: 'Test Drive',
  tradeIn: 'Trade In',
  general: 'General',
  HubungiKami: 'Hubungi Kami',
};
